<template>
  <div class="bg-color">
    <div class="wrapper clearFix">
      <!--Left模块-->
      <div class="left">
        <dl class="lt-menu">
          <dt>混改服务</dt>
          <dd>
            <router-link to='/author'>新闻资讯</router-link>
          </dd>
          <dd>
            <router-link to='/policy'>政策法规</router-link>
          </dd>
          <dd class="on">
            <router-link to='/case'>案例分析</router-link>
          </dd>
          <dd>
            <router-link to='/partake'>如何参与</router-link>
          </dd>
          <dd>
            <router-link to='/problem'>常见问题</router-link>
          </dd>
        </dl>

      </div>
      <!--End:Left模块-->
      <!--Right模块-->
      <div class="right" id="right_div">
        <ul class="notice-list" v-for="info in caseList" >
          <li>
            <div class="txt">
              <div class="title"><a><router-link :to="{path:'/serviceDetail',query: {id: info.id,catid: 13}}">· {{info.title}}</router-link></a></div>
            </div>
            <div class="date">
              <span class="year">{{info.updatetime|dateFormat}}</span>
            </div>
          </li>
        </ul>
        <div style="text-align: center;margin-top:50px;display: none;" id="noService">
          <img src="../assets/no-data.png">
        </div>
        <div id="promptInfo" style="text-align: center;color:#666;margin-top:20px;"></div>
      </div>
      <!--End:Right模块-->
      <div class="to-top" style="display: none" v-on:click="toTop()">
        <img src="../assets/top.png">
      </div>
    </div>
  </div>
</template>

<style scoped>
  @import "../style/service.css";
</style>

<script>
import global from '../components/public/Common.vue';
export default {
  name: 'author',
  computed: {
  },
  data() {
    return {
      serviceUrl:global.serviceUrl,
      token:global.token,
      orgid:global.orgid,

      pageIndex:1, //当前页数，默认为1
      totalIndex:0, //总页数
      totalData:0, //总记录数
      caseList: [],//数组，存储记录
      noMore:false,    //没有更多了
      lock:false,       //锁，防止滚动到最后时多次执行加载
    }
  },
  created: function () {
    //首次进入页面，获取第一页数据
    loadData(this,this.pageIndex,this.serviceUrl,this.token,this.orgid);

    $(window).scroll(function(){
      if($(window).scrollTop()<1000){
        $(".to-top").hide();
      }else{
        $(".to-top").show();
      }
    });

    // window.addEventListener('scroll',this.scrollEnd);//下拉加载数据
    if (document.addEventListener) {
      //webkit
      document.addEventListener('mousewheel', this.scrollEnd, false);
      //firefox
      document.addEventListener('DOMMouseScroll', this.scrollEnd, false);

    }else if(window.attachEvent){//IE
      document.attachEvent('onmousewheel',this.scrollEnd);
    }

    //触摸屏下拉加载
    var startX;                     //触摸起始横坐标
    var startY;                    //触摸起始纵坐标
    var moveSpave;                //移动的距离
    var isMoveX = true;          //判断是否为左右移动
    var isFirst = true;          //是否要判断touchmove方向
    var beginTime = 0;
    //监听 触摸事件
    document.querySelector("body").addEventListener('touchstart', function (event) {
      startX = event.targetTouches[0].pageX; //触摸起始位置赋值 相对于屏幕的 横向坐标
      startY = event.targetTouches[0].pageY; //触摸起始位置赋值 相对于屏幕的 纵向坐标
      isFirst = true;
      beginTime = new Date().getTime();
    });
    //监听 触摸滑动事件
    document.querySelector("body").addEventListener('touchmove', function (e) {
      var moveX = e.targetTouches[0].pageX; //触摸的位置   相对于屏幕的 横向坐标
      var moveY = e.targetTouches[0].pageY; //触摸的位置   相对于屏幕的 纵向坐标
      if (isFirst) {
        Math.abs(moveX - startX) - Math.abs(moveY - startY) >= 2 ? isMoveX = true : isMoveX = false;
        isFirst = false;
        //return;
      }
      if (isMoveX) {
        //水平滑动
        moveSpave = moveX - startX;
      } else {
        //竖直滑动
        moveSpave = moveY - startY;
        if (moveSpave > 0) {
          //$('.preloader').addClass('visible');
        } else {
          //$('.addajax').addClass('visible');
        }
      }
    });

    //监听触摸离开事件
    document.querySelector("body").addEventListener('touchend', function (e) {
      let _this = this;
      var endtime = new Date().getTime();
      if ((endtime - beginTime) < 100) {
        //时间小于0.1秒
        return;
      } else {
        if (isMoveX) { //当是水平拖动操作的时候
          if (moveSpave < 0) {
          } else if (moveSpave > 0) {
          }
        } else {
          //alert("垂直拖动");
          if (moveSpave < 0) {  //向上滑动
            //alert("000");
            if (_this.noMore) {
              return false;
            }
            if (!_this.lock) {
              _this.lock = true;//锁住
              loadData(_this,_this.pageIndex,_this.serviceUrl,_this.token,_this.orgid);
            }
          } else if (moveSpave > 0) { //向下滑动  加载数据}
          }
        }
      }
    });
  },
  mounted: function () {
    //在线客服
    // const oScript = document.createElement('script');
    // oScript.type = 'text/javascript';
    // oScript.src = 'https://qiyukf.com/script/114476681b34a2798e2b4dabdd9b9235.js';
    // document.body.appendChild(oScript);
  },
  destroyed(){
    // window.removeEventListener('scroll', this.scrollEnd);//监听页面滚动事件
  },
  watch: {
//    '$route': 'fetchData'
  },
  methods: {
    scrollEnd(e){
      e = e || window.event;
      if (e.wheelDelta) {  //判断浏览器IE，谷歌滑轮事件
        if (e.wheelDelta > 0) { //当滑轮向上滚动时
          // alert("滑轮向上滚动");
        }
        if (e.wheelDelta < 0) { //当滑轮向下滚动时
          //alert("滑轮向下滚动");
          // 判断是否滚动到底部
          var scrollTopHeight = parseInt(document.documentElement.scrollTop);
          var scrollTopBodyHeight = parseInt(document.body.scrollTop);
          var offsetHeight = document.body.offsetHeight;
          if (( scrollTopHeight|| parseInt(window.pageYOffset) || scrollTopBodyHeight) + window.innerHeight >= offsetHeight-20) {
            if (this.noMore) {
              return false;
            }
            if (!this.lock) {
              this.lock = true;//锁住
              loadData(this,this.pageIndex,this.serviceUrl,this.token,this.orgid);
            }
          }

        }
      } else if (e.detail) {  //Firefox滑轮事件
        if (e.detail> 0) { //当滑轮向上滚动时
          //alert("滑轮向上滚动");
          // 滚动的高度
          var scrollTopHeight = parseInt(document.documentElement.scrollTop);
          var scrollTopBodyHeight = parseInt(document.body.scrollTop);
          var offsetHeight = document.body.offsetHeight;
          if (( scrollTopHeight|| parseInt(window.pageYOffset) || scrollTopBodyHeight) + window.innerHeight >= offsetHeight-20) {
            if (this.noMore) {
              return false;
            }
            if (!this.lock) {
              this.lock = true;//锁住
              loadData(this,this.pageIndex,this.serviceUrl,this.token,this.orgid);
            }
          }

        }
        if (e.detail< 0) { //当滑轮向下滚动时
          //alert("滑轮向下滚动");
        }
      }
    },
    toTop:function () {
      $("html,body").animate({
        scrollTop: 0
      }, 500);
    }
  },
  filters: {
    dateFormat:function(time) {
      return global.dateFormatYmd(time)
    },
  }
}
/**
 * 网络请求获取数据
 * @param tar
 * @param pageIndex 当前页数
 */
 function loadData(tar,pageIndex,url,token,orgid) {
     if (pageIndex > 1) {
       $("#promptInfo").html("数据加载中...");
     } else {
       $("#promptInfo").html("");
     }
   $.ajax({
     url: url,
     type: 'post',
     dataType: 'jsonp',
     data: {
       'token':token,
       'catid':13,
       'orgid':orgid,
       'pageIndex':pageIndex,
       'pageSize':10
     },
     success: function (data) {
       //console.log(data);
       if (data.msg == 200) {
         tar.totalIndex = data.result.totalPage;
         tar.totalData = data.result.totalData;

         if (tar.totalData == 0) {//数据为空
           $("#noService").css("display", "block");
           return;
         }
         if (tar.pageIndex < tar.totalIndex) {//未加载完全
           tar.pageIndex++;
           tar.lock = false;//解锁
           tar.noMore = false;//有更多
         }else  {//加载完毕
           tar.noMore = true;//无更多
           if (data.result.totalData < 10 && data.result.pageIndex == 1)  {
             $("#promptInfo").html("");
           } else {
             $("#promptInfo").html("------没有更多了------");
           }
         }
         //添加数据
         tar.caseList = tar.caseList.concat(data.result.data);

       } else {
         $("#noService").css("display", "block");
         alert(data.msg);
       }

     },
     error: function (data) {
       tar.lock = true;
     }
   });
 }
</script>

<style lang="stylus">

</style>



// WEBPACK FOOTER //
// src/components/Case.vue